import CodeMirror, { Editor, EditorConfiguration } from 'codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/javascript/javascript';
import React, { Component } from 'react';
import './JsonEditor.less';

interface Props {
    onChange: (newValue: string) => unknown;
    value: string;
}


export class JsonEditor extends Component<Props> {
    private editor: Editor | null = null;

    public componentDidUpdate(): void {
        if (this.editor && this.editor.getValue() !== this.props.value) {
            this.editor.setValue(this.props.value);
        }
    }

    public render() {
        return (
            <div ref={this.handleRef} />
        );
    }

    private handleChange = () => {
        if (this.editor) {
            this.props.onChange(this.editor.getValue());
        }
    };

    private handleRef = (ref: HTMLDivElement) => {
        // Temporary so I can validate this in QA. Will remove later.
        if (!('js' in CodeMirror.modes)) {
            console.warn('CodeMirror mode for JSON is not loaded. There will be no syntax highlighting.', CodeMirror.modes);
        }

        const configuration: EditorConfiguration = {
            mode: 'application/json',
            value: this.props.value,
        };

        this.editor = CodeMirror(ref, configuration);

        this.editor.on('change', this.handleChange);
    };
}
